import { Slider } from "../card-slider/view-script.js";

const config = {
	back: '.my-aspen-featured__go--back',
	forward: '.my-aspen-featured__go--forward',
	content: '.my-aspen-featured__content',
	items: '.my-aspen-featured__items > *',
	sticky: false,
};

for ( const node of document.querySelectorAll( '.my-aspen-featured' ) ) {
	new Slider( node, config );
}
